<div class="policy-tiles margin-bottom-xmedium" [ngClass]="config?.className" *ngIf="data && data.length > 0">
  <h3 *ngIf="config?.label" class="h3-heading">{{ config?.label }}</h3>
  <div class="policy-tiles-grid grid">
    <div class="cell cell-large-col-span-6" *ngFor="let tileData of data">
      <open-tile-detail [componentDetails]="tileData" (click)="clickEvent(tileData)"></open-tile-detail>
    </div>
  </div>
</div>
